import { BaseFrontdoorAdapter } from "../frontdoor/BaseFrontdoorAdapter";

/**
 * FrontdoorGridSettingsAdapter
 * Manages lead grid settings configuration (columns, filters, sorting) via Frontdoor REST API.
 */
export class FrontdoorGridSettingsAdapter extends BaseFrontdoorAdapter {
  /**
   * Get lead grid settings for a user.
   * GET /api/lead-grid-settings/user/{userId}
   * @param {string} userId - User UUID
   */
  async getSettings(userId) {
    return this.get(`/api/lead-grid-settings/user/${userId}`);
  }

  /**
   * Get all lead grid settings.
   * GET /api/lead-grid-settings
   */
  async getAllSettings() {
    return this.get("/api/lead-grid-settings");
  }

  /**
   * Create or update lead grid settings for a user.
   * POST /api/lead-grid-settings
   * @param {string} userId - User UUID
   * @param {string[]} columns - Selected grid columns
   * @param {Object[]} [columnFilters=[]] - Active grid search filters
   * @param {Object[]} [sortingInfo=[]] - Active grid sort preferences
   */
  async saveSettings(userId, columns, columnFilters = [], sortingInfo = []) {
      const payload = {
        userId,
        gridSetting: {
          columns,
          columnFilters: [],
          sortingInfo: [],
        },
      };
      return this.post("/api/lead-grid-settings", payload)
  }
}
